import PropTypes from 'prop-types'
import styled from 'styled-components'

import Tooltip from 'components/Tooltip'

import AlertEventTime from 'pages/Device/AlertsPanel/AlertEventTime'
import Icon from 'pages/shared/Alert/Icon'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'

import { longDateWithDayOfWeekAndTime } from 'helpers/formatters'

const CLEARED_BY_TOOLTIP_TEXT = {
  alert_removed: undefined,
  snapshot_received: 'Cleared while device was offline.',
  device_reset: 'Cleared after the device rebooted.'
}

const propTypes = {
  alert: PropTypes.shape().isRequired,
  headerType: PropTypes.oneOf(['ActiveAlert', 'AlertHistory']),
  showDayRthCallback: PropTypes.func,
  alertNumber: PropTypes.number.isRequired,
}

const defaultProps = {
  alert: {},
  headerType: 'ActiveAlert',
  showDayRthCallback: () => {},
  alertNumber: 0
}

const AlertHeader = ({ alert, headerType, showDayRthCallback, alertNumber = 0 }) => {
  const { severity, description, zoneId = null, zoneName = null, occurredAt, timeZone, clearedAt = null, clearedBy } = alert

  return (
    <S.Header>
      <S.Title>
        <Icon {...{ severity }} size={'18px'} title={`System has a ${severity} Alert.`} />
        <S.Description>{alertNumber}. {description || '--'}</S.Description>
      </S.Title>
      <S.AlertDates headerType={headerType}>
        {(() => {
          if (alert.triggeredAt) {
            return <div>{longDateWithDayOfWeekAndTime(alert.triggeredAt)}</div>
          } else {
            return <AlertEventTime eventOccurredAt={Number(occurredAt)} timeZone={timeZone} showDayRthCallback={showDayRthCallback} />
          }
        })()}
      </S.AlertDates>
      <S.AlertDates headerType={headerType}>
        {
            headerType === 'AlertHistory' && occurredAt && (
              <S.AlertClearedAt>
                <Tooltip title={CLEARED_BY_TOOLTIP_TEXT[clearedBy]} placement="top">
                  <S.Label>Cleared:</S.Label>
                </Tooltip>
                <AlertEventTime eventOccurredAt={Number(clearedAt)} timeZone={timeZone} showDayRthCallback={showDayRthCallback} />
              </S.AlertClearedAt>
            )
          }
        </S.AlertDates>
    </S.Header>
  )
}

AlertHeader.propTypes = propTypes
AlertHeader.defaultProps = defaultProps

export default AlertHeader

const S = {
  Header: styled.div`
    display: flex;
    gap: 40px;
    align-items: center;
    
    @media ${screenSize.medium} {
      flex-direction: column;
      gap: 4px;
      align-items: flex-start;
      margin-bottom: 2px;
    }
  `,
  Title: styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
  `,
  Description: styled.div`
    font-weight: 600;
    color: ${color('primaryText')};
    font-size: 16px;
    text-decoration: underline;
  `,
  AlertDates: styled.div.withConfig({
    shouldForwardProp: (prop) => !['headerType'].includes(prop)
  })`
    text-align: right;

    @media ${screenSize.medium} {
      margin-left: 30px;
      text-align: left;
    }
  `,
  AlertClearedAt: styled.div`
    display: block;
  `,
  Label: styled.span`
    margin-right: 5px;
    color: ${color('secondaryText')};
  `,
  ClearByIcon: styled.i`
    margin-right: 5px;
    font-size: 16px;
    align-self: center;
  `
}
